module.exports = __webpack_public_path__ + "media/megamenu/Books-1ca42b39.jpg";